<template>
  <div class="nx-enum">
    <template v-if="!$scopedSlots.default">{{ label }}</template>
    <slot v-else name="default" :options="options_" :item="item" :label="label" />
  </div>
</template>

<script >
import { getPublicOption } from './utils';

export default {
  name: 'NxEnum',
  props: {
    options: {
      type: Array,
    },
    optionKey: {
      type: String,
    },
    value: {
      type: [String, Number, Boolean, undefined],
      required: true,
    },
  },
  computed: {
    options_() {
      if (Array.isArray(this.options)) {
        return this.options;
      }
      try {
        return this.getPublicOption(this.optionKey);
      }
      catch (e) {
        console.error('请输入正确的option-key', e);
        return [];
      }
    },
    item() {
      return this.options_.find(v => v.value === this.value) ?? {};
    },
    label() {
      return this.item?.label || '';
    },
  },
  methods: {
    getPublicOption,
  },

};
</script>

<style scoped lang="scss">

</style>
